import './model.scss'

const classNamePrefix = 'lesson-play-consult-model'

const transitionend = (function() {
  var t,
    el = document.createElement('surface'),
    transitions = {
      transition: 'transitionend',
      OTransition: 'oTransitionEnd',
      MozTransition: 'transitionend',
      WebkitTransition: 'webkitTransitionEnd'
    }
  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t]
    }
  }
})()

const render = (outer, { html, topHtml = '', changeBtn, orderBtn }) => {
  const btnHtml = `
  <div class="${classNamePrefix}-footer">
    ${topHtml}
    <div class="${classNamePrefix}-btns">
      ${
        changeBtn
          ? `<div class="${classNamePrefix}-btn-border${
              changeBtn.isBan ? ' change-ban' : ''
            }">
          <img src="${changeBtn.img}" />
          <span>${changeBtn.label}</span>
        </div>`
          : ''
      }
      <div class="${classNamePrefix}-btn">
        ${orderBtn.label}
      </div>
    </div>
  </div>
  `

  outer.innerHTML = `
    <div class="${classNamePrefix}-mask"></div>

    <div class="${classNamePrefix}-model">
      <div class="${classNamePrefix}-scroll">
        ${html()}
      </div>

      ${btnHtml}
      <div class="${classNamePrefix}-close"></div>
    </div>
  `

  if (btnHtml) {
    outer
      .querySelector(`.${classNamePrefix}-btn`)
      .addEventListener('click', orderBtn.onclick)
    changeBtn &&
      changeBtn.onclick &&
      outer
        .querySelector(`.${classNamePrefix}-btn-border`)
        .addEventListener('click', changeBtn.onclick)
  }

  outer
    .querySelector(`.${classNamePrefix}-close`)
    .addEventListener('click', () => {
      outer.hide()
    })
}

export default config => {
  const outer = document.createElement('div')
  outer.setAttribute('class', classNamePrefix)

  document.body.appendChild(outer)

  outer.show = () => {
    render(outer, config)
    setTimeout(() => {
      outer.querySelector(`.${classNamePrefix}-mask`).classList.add('in')
      outer.querySelector(`.${classNamePrefix}-model`).classList.add('in')
    }, 50)
  }

  outer.hide = () => {
    outer.querySelector(`.${classNamePrefix}-mask`).classList.remove('in')

    outer
      .querySelector(`.${classNamePrefix}-model`)
      .addEventListener(transitionend, () => {
        outer.innerHTML = ''
      })

    outer.querySelector(`.${classNamePrefix}-model`).classList.remove('in')

    typeof config.onHide === 'function' && config.onHide()
  }
  return outer
}



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/consult/model.js